import React from "react";
import { Navigate, useParams } from "react-router-dom";

const RedirectToOverview = () => {
    const { teamId } = useParams();
    return <Navigate to={`/teams/${teamId}/dashboard/insights`} replace />;
};

export default RedirectToOverview;
